import { render, staticRenderFns } from "./MessagePremiumV2.vue?vue&type=template&id=d732a70a&scoped=true&"
import script from "./MessagePremiumV2.vue?vue&type=script&lang=js&"
export * from "./MessagePremiumV2.vue?vue&type=script&lang=js&"
import style0 from "./MessagePremiumV2.vue?vue&type=style&index=0&id=d732a70a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d732a70a",
  null
  
)

export default component.exports